export { default as ContactSection } from './ContactSection';



// WEBPACK FOOTER //
// ./src/components/Footer/ContactSection/index.ts